import React from 'react';
import { Mail, Github } from 'lucide-react';
import SectionUnlock from '../components/SectionUnlock';

const ContactSection = ({ unlockedSections }) => {
  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-gray-900 to-blue-900 text-white relative">
      <SectionUnlock sectionId="contact" unlockedSections={unlockedSections}>
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="mb-8">
            <h2 className="text-4xl font-bold mb-4">Thank You for Your Consideration</h2>
            <p className="text-xl text-gray-300">
              Please do go back to my appeal :)
            </p>
          </div>

          <div className="flex justify-center gap-6 mb-8">
            {/* <a 
              href="mailto:your.email@example.com"
              className="bg-white text-gray-900 px-6 py-3 rounded-full font-medium hover:bg-gray-100 transition-colors flex items-center gap-2"
            >
              <Mail size={20} />
              Email Me
            </a>
            
            <a 
              href="https://linkedin.com/in/yourprofile"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white px-6 py-3 rounded-full font-medium hover:bg-white hover:text-gray-900 transition-colors"
            >
              LinkedIn
            </a> */}
            
            {/* <a 
              href="https://github.com/SakshiSinghh"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white px-6 py-3 rounded-full font-medium hover:bg-white hover:text-gray-900 transition-colors flex items-center gap-2"
            >
              <Github size={20} />
              GitHub
            </a> */}
          </div>

          {/* <div className="text-center">
            <div className="text-6xl mb-4 animate-pulse">🚀</div>
            <p className="text-gray-300"></p>
          </div> */}
        </div>
      </SectionUnlock>
    </section>
  );
};

export default ContactSection;